import { render, staticRenderFns } from "./GrnView.vue?vue&type=template&id=2dc70402&scoped=true&"
import script from "./GrnView.vue?vue&type=script&lang=js&"
export * from "./GrnView.vue?vue&type=script&lang=js&"
import style0 from "./GrnView.vue?vue&type=style&index=0&id=2dc70402&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc70402",
  null
  
)

export default component.exports